import { CourseMaterial } from "../coursesLoader";
import styles from "./DisplayNotes.module.scss";
import { UnsafeHtml } from "common/core-ui/UnsafeHtml";

export default function DisplayNotes({
  displayNotes,
}: Pick<CourseMaterial, "displayNotes">) {
  return (
    <>
      {displayNotes && (
        <div className={styles.displayNotes}>
          <UnsafeHtml>{displayNotes}</UnsafeHtml>
        </div>
      )}
    </>
  );
}
